import { render, staticRenderFns } from "./Tabler.vue?vue&type=template&id=06899d1f"
import script from "./Tabler.vue?vue&type=script&lang=js"
export * from "./Tabler.vue?vue&type=script&lang=js"
import style0 from "./Tabler.vue?vue&type=style&index=0&id=06899d1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports